export default function isNicknamePage(): boolean {

    let nickNameDom = document.getElementById("vwbnickname") as any;
    return (nickNameDom && nickNameDom.value.length > 0);


}